module.exports = __webpack_public_path__ + "img/country.31973ac2.png";